import {useState} from 'react';
import { Typography } from '@mui/material';

const ExpandableText =({text, maxWords, fontSize}) =>{
    const [expanded, setExpanded] = useState(false);
    const handleClick = () =>{
        setExpanded(!expanded);
    }
    const displayText = expanded? text: `${text?.split(' ').slice(0, maxWords).join(' ')}`;
    return(
        <Typography variant="body1" onClick={handleClick} style={{ cursor: 'pointer', fontSize:fontSize}}>
            {displayText}
            {expanded && 
                <button aria-label ='collapse' type='button' className='font-sans-sm' style={{border: 0, color: '#115293', textDecoration: 'underline', fontSize: fontSize, backgroundColor:'transparent', fontWeight: 'bold'}}>
                    Collapse
                </button>
            }
            {text?.length!== displayText?.length && !expanded &&            
                <button aria-label ='show more...' type='button' className='font-sans-sm' style={{border: 0, color: '#115293', textDecoration: 'underline', fontSize: fontSize, backgroundColor:'transparent', fontWeight: 'bold'}}>
                    Show More ...
                </button> 
            }
        </Typography>
    )
}

export default ExpandableText;